






















































import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getInfo, LawFileData, emptyLawFile, read, download } from '@/api/lawFile/index'
import ViewDialog from '@/components/dialog/viewDialog.vue'
import * as attApi from '@/api/common/attach'
import { fileServer } from '@/api/common/upload'

@Component({
  components: {
    ViewDialog
  }
})
export default class LawFileView extends Vue {
  public collapseNames: string[] = ['base', 'contents']
  public showDialog: boolean = false
  public loading: boolean = false

  public form: LawFileData = Object.assign({}, emptyLawFile)
  public $refs!: {}
  public created() { }
  public mounted() {
    window.eventBus.$on("viewLawFile", (id: number) => {
      this.showDialog = true
      this.fetchData(id)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("viewLawFile")
  }
  public closeDialog() {
    this.showDialog = false
  }
  public fetchData(id: number) {
    this.loading = true
    getInfo(id)
      .then((response: { data: any }) => {
        this.form = response.data
        this.loading = false
        //添加查阅记录
        read(id).then(() => { })
      })
      .catch((error: any) => {
        console.log(error)
      })
  }

  public downloadFile() {
    var f = this.form
    download(f.Id).then(() => {
      attApi.getInfo(f.Id, f.ReferType, '')
        .then((response: { data: any }) => {
          const info: attApi.AttachInfo = response.data
          var fileUrl = fileServer(info.Id, info.TempGuid, info.Name)
          console.log(info, fileUrl)
          attApi.openFile(fileUrl, info.Name)
        })
    })
  }
}
